import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import ConfirmDialog from "../components/ConfirmDialog";

const ConfirmDialogContext = createContext(null);

const DIALOG_DEFAULTS = {
  isOpen: false,
  title: "Confirmar acao",
  description: "Tem certeza que deseja continuar?",
  confirmText: "Confirmar",
  cancelText: "Cancelar",
  variant: "primary",
};

export const ConfirmDialogProvider = ({ children }) => {
  const [dialogState, setDialogState] = useState(DIALOG_DEFAULTS);
  const resolveRef = useRef(null);

  const closeDialog = useCallback((confirmed) => {
    if (resolveRef.current) {
      resolveRef.current(confirmed);
      resolveRef.current = null;
    }

    setDialogState(DIALOG_DEFAULTS);
  }, []);

  const confirmDialog = useCallback((config = {}) => {
    return new Promise((resolve) => {
      resolveRef.current = resolve;
      setDialogState({
        ...DIALOG_DEFAULTS,
        ...config,
        isOpen: true,
      });
    });
  }, []);

  useEffect(() => {
    return () => {
      if (resolveRef.current) {
        resolveRef.current(false);
        resolveRef.current = null;
      }
    };
  }, []);

  return (
    <ConfirmDialogContext.Provider value={confirmDialog}>
      {children}
      <ConfirmDialog
        isOpen={dialogState.isOpen}
        title={dialogState.title}
        description={dialogState.description}
        confirmText={dialogState.confirmText}
        cancelText={dialogState.cancelText}
        variant={dialogState.variant}
        onCancel={() => closeDialog(false)}
        onConfirm={() => closeDialog(true)}
      />
    </ConfirmDialogContext.Provider>
  );
};

export const useConfirmDialog = () => {
  const context = useContext(ConfirmDialogContext);

  if (!context) {
    throw new Error("useConfirmDialog deve ser usado dentro de ConfirmDialogProvider");
  }

  return context;
};
